import { Fragment } from "react";
import { API_ENDPOINTS } from "../config";
import { useAPI } from "../hooks/APIHook";
import { css } from "./SKT";
import { SKTBaseAutocompleteTextField } from "./SKTBaseAutocompleteTextField";

export const SKTFavoriteSelect = ({ data, prefix }) => {
  const [favorites] = useAPI(API_ENDPOINTS.profile.favorites);
  const prefixed = (key) => `${prefix}${key}`;

  const onChange = (suggestion) => {
    if (suggestion === undefined) return;

    const d = Object.keys(suggestion).reduce((prev, key) => {
      prev[prefixed(key)] = suggestion[key];
      return prev;
    }, {});
    data.setMany(d);
  };

  if (favorites.status === "pending") return <Fragment />;

  const getSuggestionValue = (option) => {
    if (option.Name2)
      return `${option.Name}, ${option.Name2}, ${option.Addr1}, ${option.ZIP}`;
    return `${option.Name}, ${option.Addr1}, ${option.ZIP}`;
  };

  const renderSuggestion = (option) => {
    return <div>{getSuggestionValue(option)}</div>;
  };

  const filterSuggestions = (inputValue) => {
    const fieldMatch = (value) =>
      value
        ? value.toLowerCase().slice(0, inputValue.length) === inputValue
        : false;
    const fieldWordMatch = (value) =>
      value
        ? value
            .split(" ")
            .reduce(
              (prev, c) =>
                prev ||
                c.toLowerCase().slice(0, inputValue.length) === inputValue,
              false
            )
        : false;
    return favorites.fav.filter((option) => {
      return (
        fieldMatch(option.Name) ||
        fieldMatch(option.Name2) ||
        fieldWordMatch(option.Name) ||
        fieldWordMatch(option.Name2) ||
        fieldMatch(option.Addr1) ||
        fieldMatch(option.ZIP)
      );
    });
  };

  return (
    <SKTBaseAutocompleteTextField
      id={`favorite_for_${prefix}`}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      filterSuggestions={filterSuggestions}
      onChange={onChange}
      placeholder="Haku osoitekirjasta ..."
    />
  );
};
